import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Link } from 'react-router-dom';

import classes from './Fab.scss';

const TRANSITION_DURATION_STEP = 90;

export default class FABItem extends Component {
  static propTypes = {
    position: PropTypes.number,
    radius  : PropTypes.number,
    margin  : PropTypes.number,
    open    : PropTypes.bool,
    item    : PropTypes.object,
    onClick : PropTypes.func,
  };

  handleLinkClick() {
    const { item, onClick } = this.props;

    item.onClick?.();
    onClick?.();
  }

  render () {
    const { position, radius, margin, open, item, children } = this.props;

    const transition = TRANSITION_DURATION_STEP + (100 * position) + 'ms';
    const translate = (radius + margin) * (position + 1) + 'px';
    const title = (item && item.title) || children;
    const iconClass = (item && item.icon) ? `ballIcon_${item.icon}` : null;

    return (
      <Link
        className = {classNames(classes.ball, classes.ballItem, { [classes.ballOpened]: open }, classes[iconClass])}
        to        = {item.href}
        onClick   = {this.handleLinkClick.bind(this)}
        style     = {{
          transitionDuration: transition,
          transform: 'translate3d(0, ' + (open ? translate : 0) + ',0)'
        }}
      >
        <span
          className={classes.ball_title}
          style={{
            transitionDelay: open ? transition : '0ms',
            transitionDuration: open ? '.3s':'0s',
          }}
        >{title}</span>
      </Link>
    );
  }
}
